module.exports = __webpack_public_path__ + "img/4.d55ab67c.jpg";